const SW_PATH = '/sw.js'

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null

export function isPwaEnabled() {
  return process.env.NEXT_PUBLIC_WEB === 'B2C'
}

function shouldRegisterServiceWorker() {
  if (!isPwaEnabled()) {
    return false
  }

  // `next dev` serves different chunk URLs than production `sw.js` precache manifest.
  // Offline/PWA must be tested via `npm run build && npm start`.
  if (process.env.NODE_ENV === 'development') {
    return false
  }

  return true
}

export function registerPwaServiceWorker() {
  if (!shouldRegisterServiceWorker()) {
    return Promise.resolve(null)
  }

  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null)
  }

  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker
      .register(SW_PATH, {
        scope: '/',
        updateViaCache: 'none',
      })
      .catch((error) => {
        registrationPromise = null
        console.error('PWA service worker registration failed:', error)
        return null
      })
  }

  return registrationPromise
}
